export default __webpack_public_path__ + "static/media/exams.c22fde66.svg";